module.exports = __webpack_public_path__ + "img/marketingInformationBroadband.png";